module.exports = __webpack_public_path__ + "img/thumb-2.a0f2b9f6.png";